"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFlame = function IconFlame(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.015 8.769A7.3 7.3 0 0 1 12.062 3l5.502 5.5a7.6 7.6 0 0 1 1.826 3.9q.09.546.099 1.1-.001.359-.035.709c-.013.136-.035.27-.056.403l-.008.05-.011.076q-.008.066-.021.132a6 6 0 0 1-.133.578l-.012.046q-.091.307-.2.606a7.51 7.51 0 0 1-4.121 4.292l-.031.013L12 17.544l-2.881 2.888s-.557-.247-.885-.436l-.153-.093a7.6 7.6 0 0 1-.943-.677l-.073-.065a7.5 7.5 0 0 1-1.567-1.9l-.041-.066q-.3-.532-.509-1.107l-.04-.108a7.4 7.4 0 0 1-.31-1.192q-.002-.01-.006-.019-.005-.014-.006-.027l.006.006a7.4 7.4 0 0 1-.113-1.248 7.62 7.62 0 0 1 1.921-5l.247-.246c1.6 1.587 2.231 2.169 2.445 2.169.143 0 .1-.26.036-.652a7 7 0 0 1-.113-1.002m7.09 1.102-4.049-4.049-.001-.003a4.52 4.52 0 0 0-1.042 2.9 5.5 5.5 0 0 0 .087.727 2.56 2.56 0 0 1-.416 2.247 2.08 2.08 0 0 1-1.587.732c-.728 0-1.232-.266-2.15-1.1-.3.69-.457 1.434-.463 2.187q.005.454.085.9l.016.1q.077.409.215.8l.016.07q.151.414.365.8l.035.056c.306.53.697 1.005 1.159 1.407l.025.022.064.052q.144.124.3.233l1.822-1.822L12 14.716l1.41 1.411 1.8 1.8a5.48 5.48 0 0 0 2.176-3.423l.025-.167.01-.067a4 4 0 0 0 .063-.774 5.4 5.4 0 0 0-.072-.789l-.007-.049a5.6 5.6 0 0 0-1.3-2.787",
    clipRule: "evenodd"
  })));
};

export { IconFlame, IconFlame as default };
